import { render, staticRenderFns } from "./org-detail-main.vue?vue&type=template&id=3f4e0d5d&"
import script from "./org-detail-main.vue?vue&type=script&lang=js&"
export * from "./org-detail-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports